<template>
  <b-card no-body class="p-3" v-loading="is_loading">
    <b-row class="d-flex align-items-center">
			<b-col cols="9">
				<p v-if="!_gHlp.isEmpty(latestLog)">
					<b>LATEST LOG : </b> <span v-html="latestLog.messages"></span><br/>
					<small>{{ latestLog.created_at | dateTimeFormatString }}</small>
				</p>

			</b-col>
			<b-col cols="3" class="text-right">
				<span v-if="!_gHlp.isEmpty(activeLoanEC)" class="mx-2 py-0 text-primary text-xs" style="cursor: pointer;"
					@click="$refs.drawer_activity_log.show()">
					Show Log
					<b-icon icon="chevron-right"></b-icon>
				</span>
			</b-col>
		</b-row>

		<b-tabs justified class="mt-2"
			v-if="_gAuth.hasAccess(['role_credit_heads', 'role_credit_manager', 'role_admin', 'role_super_admin', 'role_admin_support'])">
			<b-tab active title-item-class="disabledTab">
				<template #title>
					<svg v-if="_gHlp.getValue(activeLoanEC,'status') == 'Pending Approval'" xmlns="http://www.w3.org/2000/svg"
						class="mr-2" width="18" height="18" viewBox="0 0 512 512">
						<path fill="currentColor"
							d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512zm113-303L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
					</svg>
					Officer 
				</template>
			</b-tab>
			<b-tab title-item-class="disabledTab" title="Credit View"
				:active="_gHlp.getValue(activeLoanEC,'status') == 'Pending Approval'"></b-tab>
		</b-tabs>
		
		<DrawerActivityLog ref="drawer_activity_log" :tags="'#loan_ec_' + _gHlp.getValue(activeLoanEC, 'id')" />
  </b-card>
</template>
<script>

import DrawerActivityLog from '@/views/CustomerProfile/Drawers/DrawerActivityLog/ActivityLog'
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useCommonStore } from '@/stores/commonStore';

export default {
  props: ['loan-ec', 'is-view-only'],
  data() {
    return {
			tableData:[]
		}
  },
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	components: {
		DrawerActivityLog
	},
  computed: {
		...mapState(useCommonStore, ['loanTypes']),
		...mapState(useCustomerStore, ['activeLoanEC']),
		latestLog(){
			// console.log(_gHlp.getValue(this.tableData,'0'))
			return _gHlp.getValue(this.tableData,'0')
		},
		is_loading(){
			return _gHlp.isLoading('fetch_loan_ec') || _gHlp.isLoading('fetch_lates_log')
		}
	},
	watch: {
		activeLoanEC: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.initComponent();
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useCustomerStore, ['updateLoanEC','getActivityLogList']),
		clearComponent(){
			this.tableData = []
		},
		initComponent() {
			_gHlp.setLoading('fetch_lates_log')
			this.tableData = [];
			let params = {
				search: {
					tags: '#loan_ec_' + _gHlp.getValue(this.activeLoanEC, 'id')+'#'
				}
			}
			this.getActivityLogList(params).then(resp => {
				this.tableData = resp.data;
				_gHlp.removeLoading('fetch_lates_log')
			}).catch(err=>{
				_gHlp.removeLoading('fetch_lates_log')
			})
		},
  }
}
</script>